import React, { useCallback, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Heading, Text } from '../../../mo-gel';

import Logo from '../../../images/BTI_logo_2020_white-blue.svg';
import { Link } from '../../../typings/Links.type';

import {
  SyledSubNavigationList,
  StyledSubNavLink,
  StyledNav,
  StyledMenuList,
  StyledLogo,
  StyledMenuToggle,
  StyledNavLinkContainer,
  StyledListItem,
  StyledNavLink,
  StyledLink
} from './MobileHeader.styled';

export interface MobileHeaderProps {
  navLinks: Link[];
  whoForNavLinks: Link[];
}

export const MobileHeader = ({ navLinks, whoForNavLinks }: MobileHeaderProps) => {
  const [showNavigation, setShowNavigation] = useState(false);
  const [showSubNavigation] = useState(true);

  const toggleNavigation = useCallback(() => {
    setShowNavigation((current) => !current);
  }, []);

  const renderSubNavigationLinks = (linkTitle: string) => {
    if (linkTitle !== "Who's it for?") {
      return null;
    }

    return (
      <SyledSubNavigationList>
        {whoForNavLinks.map((navLink: Link, index: number) => (
          <StyledSubNavLink
            key={`sub-navigation-link-${index}`}
            to={navLink.link}
            onClick={toggleNavigation}
            role="button"
          >
            <Text>{navLink.title}</Text>
          </StyledSubNavLink>
        ))}
      </SyledSubNavigationList>
    );
  };

  return (
    <StyledNav>
      <StyledMenuList $showNavigation={showNavigation}>
        {!showNavigation && (
          <NavLink to="/">
            <StyledLogo src={Logo} />
          </NavLink>
        )}
        <StyledMenuToggle>
          <input type="checkbox" checked={showNavigation} onChange={toggleNavigation} />
          <span />
          <span />
          <span />
          <div />
        </StyledMenuToggle>

        <StyledNavLinkContainer>
          {showNavigation &&
            navLinks.map((navLink: Link, index: number) => (
              <React.Fragment key={`navigation-link-${index}`}>
                <StyledListItem>
                  {navLink.title === 'Login' ? (
                    <StyledLink
                      href="https://cloud.scorm.com/sc/InvitationConfirmEmail?publicInvitationId=2bba9498-5893-4585-b47a-2a202d020923"
                      onClick={toggleNavigation}
                    >
                      <Heading level="h3">{navLink.title}</Heading>
                    </StyledLink>
                  ) : (
                    <StyledNavLink to={navLink.link} onClick={toggleNavigation}>
                      <Heading level="h3">{navLink.title}</Heading>
                    </StyledNavLink>
                  )}
                </StyledListItem>
                {showSubNavigation && renderSubNavigationLinks(navLink.title)}
              </React.Fragment>
            ))}
        </StyledNavLinkContainer>
      </StyledMenuList>
    </StyledNav>
  );
};
